import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Logo from "../Assets/logo.png";
import "./PurchasePrint.css";

const ProformaPrint = () => {
    const [proformaData, setProformaData] = useState(null);
    const { id } = useParams();

    const dummyProformas = [
        {
            id: 1,
            proformaId: "PRO-001",
            date: "2025-11-21",
            customer: "John Doe",
            customerPhone: "9876543210",
            customerAddress: "123 Main Street, Bangalore, Karnataka - 560001",
            seller_detail: {
                shop_name: "SDS POLYTECHNIC",
                address: "College Road, Campus Area",
                city: "Coimbatore",
                state: "Tamil Nadu",
                pincode: "641012",
                phone: "0422-1234567",
                email: "admin@sdpolytechnic.edu.in",
                gst_no: "33ABCDE1234F1Z5"
            },
            items: [
                {
                    id: 1,
                    product_name: "Pin Box - (00:4)",
                    selling_rate: 200.0,
                    qty: 50,
                    unit: "PCS",
                    total_per_product: 10000.0
                }
            ],
            subTotal: 10000.0,
            gst_percentage: 18,
            gst_amount: 1800.0,
            grandTotal: 11800.0,
            status: "Draft"
        }
    ];

    useEffect(() => {
        const found = dummyProformas.find(p => p.id === parseInt(id));
        if (found) setProformaData(found);

        setTimeout(() => window.print(), 800);
    }, [id]);

    if (!proformaData) return null;

    return (
        <div className="print-page">

            {/* FULL PAGE BORDER */}
            <div className="page-border"></div>

            <div className="print-content">

                {/* HEADER */}
                <div className="header-section">
                    <div>GSTIN No: {proformaData.seller_detail.gst_no}</div>
                    <div className="title">Proforma Invoice</div>
                </div>

                <div className="company-section">
                    <img src={Logo} width="70" alt="Logo" />
                    <div className="company-details">
                        <h2>{proformaData.seller_detail.shop_name}</h2>
                        <div>{proformaData.seller_detail.address}</div>
                        <div>
                            {proformaData.seller_detail.city},{" "}
                            {proformaData.seller_detail.state} -{" "}
                            {proformaData.seller_detail.pincode}
                        </div>
                        <div>Mobile: {proformaData.seller_detail.phone}</div>
                    </div>
                </div>

                {/* BILL INFO */}
                <div className="bill-info">
                    <div><b>Proforma No:</b> {proformaData.proformaId}</div>
                    <div><b>Date:</b> {proformaData.date}</div>
                </div>

                {/* CUSTOMER */}
                <div className="customer-info">
                    <b>Customer:</b> {proformaData.customer}, {proformaData.customerAddress}  
                    , Ph: {proformaData.customerPhone}
                </div>

                {/* ITEMS TABLE */}
                <table className="items-table">
                    <thead>
                        <tr>
                            <th>S.No</th>
                            <th>Product Name</th>
                            <th>Rate</th>
                            <th>Qty</th>
                            <th>Total</th>
                        </tr>
                    </thead>
                    <tbody>
                        {proformaData.items.map((item, index) => (
                            <tr key={item.id}>
                                <td>{index + 1}</td>
                                <td>{item.product_name}</td>
                                <td>{item.selling_rate.toFixed(2)}</td>
                                <td>{item.qty} {item.unit}</td>
                                <td>₹ {item.total_per_product.toFixed(2)}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>

                {/* TOTALS */}
                <div className="totals-section">
                    <div>Sub Total: ₹ {proformaData.subTotal.toFixed(2)}</div>
                    <div>GST ({proformaData.gst_percentage}%): ₹ {proformaData.gst_amount.toFixed(2)}</div>
                    <div className="grand-total">Grand Total: ₹ {proformaData.grandTotal.toFixed(2)}</div>
                </div>

                <div className="footer-text">
                    This is a Computer Generated Proforma Invoice
                </div>

            </div>
        </div>
    );
};

export default ProformaPrint;